'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosKeypadOutline = function IoIosKeypadOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30.9 26.6c2.3 0 4.1 1.9 4.1 4.3s-1.8 4.1-4.1 4.1-4.3-1.8-4.3-4.1 1.9-4.3 4.3-4.3z m0 7.2c1.6 0 2.9-1.3 2.9-2.9s-1.3-3-2.9-3-3 1.3-3 3 1.3 2.9 3 2.9z m-10.9-7.2c2.3 0 4.1 1.9 4.1 4.3s-1.8 4.1-4.1 4.1-4.1-1.8-4.1-4.1 1.8-4.3 4.1-4.3z m0 7.2c1.6 0 2.9-1.3 2.9-2.9s-1.3-3-2.9-3-2.9 1.3-2.9 3 1.3 2.9 2.9 2.9z m-10.9-7.2c2.4 0 4.3 1.9 4.3 4.3s-1.9 4.1-4.3 4.1-4.1-1.8-4.1-4.1 1.8-4.3 4.1-4.3z m0 7.2c1.7 0 3-1.3 3-2.9s-1.3-3-3-3-2.8 1.3-2.8 3 1.2 2.9 2.8 2.9z m21.8-17.9c2.3 0 4.1 1.8 4.1 4.1s-1.8 4.1-4.1 4.1-4.3-1.8-4.3-4.1 1.9-4.1 4.3-4.1z m0 7c1.6 0 2.9-1.3 2.9-2.9s-1.3-2.9-2.9-2.9-3 1.3-3 2.9 1.3 2.9 3 2.9z m-10.9-7c2.3 0 4.1 1.8 4.1 4.1s-1.8 4.1-4.1 4.1-4.1-1.8-4.1-4.1 1.8-4.1 4.1-4.1z m0 7c1.6 0 2.9-1.3 2.9-2.9s-1.3-2.9-2.9-2.9-2.9 1.3-2.9 2.9 1.3 2.9 2.9 2.9z m-10.9-7c2.4 0 4.3 1.8 4.3 4.1s-1.9 4.1-4.3 4.1-4.1-1.8-4.1-4.1 1.8-4.1 4.1-4.1z m0 7c1.7 0 3-1.3 3-2.9s-1.3-2.9-3-2.9-2.8 1.3-2.8 2.9 1.2 2.9 2.8 2.9z m21.8-9.5c-2.4 0-4.3-1.9-4.3-4.3s1.9-4.1 4.3-4.1 4.1 1.8 4.1 4.1-1.8 4.3-4.1 4.3z m0-7.1c-1.7 0-3 1.2-3 2.8s1.3 3 3 3 2.9-1.3 2.9-3-1.3-2.8-2.9-2.8z m-10.9-1.3c2.3 0 4.1 1.8 4.1 4.1s-1.8 4.3-4.1 4.3-4.1-1.9-4.1-4.3 1.8-4.1 4.1-4.1z m0 7.1c1.6 0 2.9-1.3 2.9-3s-1.3-2.8-2.9-2.8-2.9 1.2-2.9 2.8 1.3 3 2.9 3z m-10.9-7.1c2.4 0 4.3 1.8 4.3 4.1s-1.9 4.3-4.3 4.3-4.1-1.9-4.1-4.3 1.8-4.1 4.1-4.1z m0 7.1c1.7 0 3-1.3 3-3s-1.3-2.8-3-2.8-2.8 1.2-2.8 2.8 1.2 3 2.8 3z' })
        )
    );
};

exports.default = IoIosKeypadOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-keypad-outline.js
// module id = 2426
// module chunks = 0